export default "{\n    \"searchPlaceholder\": \"Search by name\",\n    \"emptySearchPlaceholder\": \"Click to select an ops owner\"\n}\n"